import { render } from "./LottieImage.vue?vue&type=template&id=2eed8fee"
import script from "./LottieImage.vue?vue&type=script&lang=js"
export * from "./LottieImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__